<template>
  <div class="mrc-grey">
    <v-layout
        row
        wrap
      align-start
    >
      <v-flex
        md12
        lg12
        xl12
        class="py-0 my-0"
      >
        <h4 class="mrc-label">Driver Payment</h4>
      </v-flex>
      <v-flex>
        <v-layout
          v-if="!bookingIsCancelled"
          shrink

          ma-1
          mt-0
          pr-2
          wrap
          :class="{ 'change-cost-panel': bookingIsCompletedOrCancelled }"
          class="enabled-panel"
        >
          <v-flex
            lg12
            xl12
            md12
          >
            <v-layout>
              <v-flex
                v-if="
                  (bookingForm.booking.payment_type == 'card' ||
                    bookingForm.booking.payment_type == 'account') &&
                    bookingForm.booking.fixed_cost == true
                "
                pt-2
                shrink
              >
                <div>
                  <SimpleCurrencyInput
                    :width="'70px'"
                    v-model="bookingForm.booking.final_cost_driver"
                    label="Driver Fare"
                    :error="bookingForm.errors.final_cost_driver"
                    @input="finalCostDriverChanged"
                  />
                </div>
              </v-flex>
<!--
              <v-flex
                v-if="finalDriverFareIncludingAdditionals()"
                pt-2
                px-1
                grow
              >
                <p
                  style="font-size: 11px; font-weight: 500"
                  class="mt-1"
                >
                  Final <br> <span style="margin-top: 1px"> £{{ finalDriverFareIncludingAdditionals() }}</span>
                </p>
              </v-flex>
-->

              <v-flex
                pt-2
                grow
              >
                <div>
                  <SimpleCurrencyInput
                    v-model="bookingForm.booking.fixed_commission"
                    label="Fixed Commission"
                    :error="bookingForm.errors.fixed_commission"
                    @input="finalCostChanged"
                  />
                </div>
              </v-flex>
              <v-flex
                v-if="driverFinalAfterCommission()"
                pt-2
                px-1
              >
                <p
                  style="font-size: 11px; font-weight: 500"
                  class="mt-1"
                >
                  <span class="cmr-label-text" title="20% default commission value">
                    Commission ({{bookingForm.booking.driver_percentage ? bookingForm.booking.driver_percentage : '20' }}%)
                  </span><br>
                  <span class="cmr-value-text" style="margin-top: 1px;" v-if="bookingForm.booking.fixed_commission == null">
                    £{{ bookingForm.booking.driver_fare_commission ? bookingForm.booking.driver_fare_commission.toFixed(2) : 0 }}
                  </span>
                  <span class="cmr-value-text" style="margin-top: 1px;" v-else>
                    £{{ bookingForm.booking.fixed_commission }}
                  </span>
                </p>
              </v-flex>
              <v-flex
                v-if="driverFinalAfterCommission()"
                pt-2
                px-1
              >
                <p
                  style="font-size: 11px; font-weight: 500"
                  class="mt-1"
                >
                  <span class="cmr-label-text">
                  Final After Commission
                  </span>
                  <br>
                  <span class="cmr-value-text" style="margin-top: 1px">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;£{{ driverFinalAfterCommission() }}
                  </span>
                </p>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

import SimpleCurrencyInput from './SimpleCurrencyInputV2'
export default {
  name: "DriverPaymentInput",
  components: {
    SimpleCurrencyInput
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    hideAdditionalCharge: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      menu: false,
      addingCard: false,
      addingPromocode: false,
    };
  },
  watch: {
    "bookingForm.booking.payment_type" () {
      if(this.bookingForm.booking.payment_type != 'card' &&
          this.bookingForm.booking.payment_type != 'account') {
        this.bookingForm.booking.final_cost_driver = null
      }
      this.finalCostChanged()
      this.finalDriverFareIncludingAdditionals()
      this.driverFinalAfterCommission()
      console.log('payment type changed')
    },
  },
  computed: {
    bookingIsNotBooked() {
      return this.bookingForm.booking.state == null;
    },
    bookingIsCancelled() {
      return this.bookingForm.booking.state == "cancelled";
    },
    bookingIsCompletedOrCancelled() {
      return (
          this.bookingForm.booking.state == "completed" ||
          this.bookingForm.booking.state == "cancelled"
      );
    },
  },
  methods: {
    finalCostIncludingAdditionals: function () {
      var additionalCharges = 0;

      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }

      if (this.bookingForm.booking.final_fare != 0) {
        var finalFare = this.bookingForm.booking.final_fare;
        console.log("final fare",  finalFare)
        if (finalFare != 0 && finalFare != null) {
          return ((finalFare) + additionalCharges / 100).toFixed(2);
        } else {
          if (this.getCost()) {
            return (this.getCost()/100 + additionalCharges / 100).toFixed(2);
          }
        }

      } else {
        return null;
      }
    },
    finalDriverFareIncludingAdditionals: function () {
      var additionalCharges = 0;
      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }

      if (this.bookingForm.booking.final_cost_driver != 0 || this.bookingForm.booking.final_fare != 0) {
        var finalFare = this.bookingForm.booking.final_cost_driver;
        if (!finalFare) {
          finalFare = this.bookingForm.booking.final_fare
        }
        console.log("final fare",  finalFare)
        if (finalFare != 0 && finalFare != null) {
          return ((finalFare) + additionalCharges / 100).toFixed(2);
        } else {
          if (this.getCost()) {

            return (this.getCost()/100 + additionalCharges / 100).toFixed(2);
          }
        }

      } else {
        return null;
      }
    },
    driverFinalAfterCommission: function () {
      var additionalCharges = 0;
      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }

      if (this.bookingForm.booking.final_fare_driver != 0) {
        var finalFare = this.bookingForm.booking.final_cost_driver;
        if (!finalFare) {
          finalFare = this.bookingForm.booking.final_fare
        }
        if(!finalFare) {
          finalFare = (this.getCost()/100 ).toFixed(2);
        }
        if (finalFare) {
          if (this.bookingForm.booking.fixed_commission != 0 && this.bookingForm.booking.fixed_commission > 0) {
            console.log('fixed commission check', this.bookingForm.booking.fixed_commission)
            finalFare -= this.bookingForm.booking.fixed_commission
          } else if (this.bookingForm.booking.fixed_commission == 0) {
            console.log('fixed commission check', this.bookingForm.booking.fixed_commission)
            finalFare -= this.bookingForm.booking.fixed_commission
          } else {
            console.log('fixed commission check', this.bookingForm.booking.fixed_commission)
            finalFare -= this.bookingForm.booking.driver_fare_commission
          }
        }
        if (finalFare != 0 && finalFare != null) {
          return ((finalFare) + additionalCharges / 100).toFixed(2);
        } else {
          if (this.getCost()) {
            return (this.getCost()/100 + additionalCharges / 100).toFixed(2);
          }
        }

      } else {
        return null;
      }
    },
    costOfAdditionals: function () {
      var additionalCharges = 0;

      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }

      return (additionalCharges / 100).toFixed(2);
    },
    getCost: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });
        if (costForRideType != null) {
          return costForRideType.estimate;
        } else {
          return null;
        }
      }
    },
    finalCostChanged: function (finalCost) {
      console.log("FINAL COST CHANGED " + finalCost);

    },
    finalCostDriverChanged: function (finalCost) {
      console.log("changed " + finalCost);
      this.bookingForm.updateDriverCommission()
      this.bookingForm.booking.final_cost_driver = finalCost;

      if (finalCost != null) {
        this.bookingForm.booking.fixed_cost_driver = true;
        this.bookingForm.booking.fixedCostDriverType = this.bookingForm.FIXED_COST_DISPATCHER();
      } else {
        this.bookingForm.booking.fixed_cost_driver = false;
        this.bookingForm.booking.fixedCostDriverType = null;
      }
    },
    updateFinalCosts: function () {
      this.$emit("updateFinalCosts", null);
    },
    changePaymentTypeToCard: function (card) {
      console.log("CHANGE PAYMENT TYPE TO CARD");
      this.bookingForm.changePaymentType("card", card);
    },
    changePaymentType: function (paymentType) {
      this.bookingForm.changePaymentType(paymentType, null);
    },
    changePromocode: function (promocode) {
      this.bookingForm.changePromocode(promocode);
    },
    changeAdditionalCharge: function (additionalCharge) {
      this.bookingForm.additional_charge = additionalCharge;
      this.bookingForm.getCostEstimate();
    },
    getCostEstimate: function() {
      this.bookingForm.getCostEstimate();
    },
    changeFinalCost: function (finalCost) {

      console.log("FINAL COST CHANGED DISPATCHER" + finalCost);

      this.bookingForm.booking.final_cost = finalCost;
    },
    changeFinalCostDriver: function (finalCostDriver) {
      this.bookingForm.booking.final_cost_driver = finalCostDriver;
      this.bookingForm.booking.fixedCostDriverType = this.bookingForm.FIXED_COST_DISPATCHER();
    },
    changePaymentTypeToCardWithToken(token) {
      this.addingCard = false;
      this.bookingForm.changePaymentType("card", token.card.id);
    },
    changePromocode(promocode) {
      this.addingPromocode = false;
      this.bookingForm.changePromocode(promocode);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled-panel {
  pointer-events: none;
}

.enabled-panel {
  pointer-events: auto;
}

.change-cost-panel {
  padding: 8px;
  background-color: #e3f2fd;
}

.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}

.small-fab {
  transform: scale(0.7);
  transform-origin: bottom;
}

.small-fab button {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
</style>
